import React, { lazy } from 'react';
import { CONSTANTS } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
import { Gift, ChevronRight } from 'lucide-react';
export const BonusSection: React.FC = () => {
  const bonuses = [{
    title: 'Plantilla de Plan Anual Editable',
    desc: 'Organizá todo tu año de clases con esta plantilla editable en Excel y Google Sheets'
  }, {
    title: 'Checklist de Seguridad para el Entrenador',
    desc: 'Verificá todos los puntos de seguridad antes, durante y después de cada clase'
  }, {
    title: 'Guía Rápida de Comunicación con Padres',
    desc: 'Plantillas de mensajes y scripts para comunicarte eficazmente con las familias'
  }, {
    title: 'Selección de Ejercicios Favoritos por Aparato',
    desc: 'Los mejores ejercicios organizados por aparato gimnástico para acceso rápido'
  }, {
    title: 'Plantilla de Evaluación del Gimnasta por Aparato',
    desc: 'Sistema completo para evaluar el progreso de cada alumno de forma profesional'
  }];
  return <section className="py-20 bg-gray-900 text-white" data-id="element-19">
      <div className="max-w-6xl mx-auto px-4" data-id="element-20">
        <div className="text-center mb-16" data-id="element-21">
          <div className="inline-flex items-center justify-center space-x-2 bg-red-600 text-white px-6 py-2 rounded-full font-bold uppercase tracking-wider mb-6" data-id="element-22">
            <Gift className="w-5 h-5" data-id="element-23" />
            <span data-id="element-24">Oferta Especial Limitada</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold mb-6" data-id="element-25">
            Además, si comprás hoy te llevás <br className="hidden md:block" data-id="element-26" />
            <span className="text-yellow-400" data-id="element-27">5 BONOS EXCLUSIVOS GRATIS</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-28">
          {bonuses.map((bonus, index) => <div key={index} className="bg-gray-800 rounded-2xl p-6 border border-gray-700 flex flex-col sm:flex-row items-center sm:items-start gap-6 hover:border-yellow-400 transition-colors cursor-pointer group" onClick={scrollToOffer} data-id="element-29">
              <div className="w-32 h-32 flex-shrink-0 relative rounded-xl overflow-hidden bg-gray-700 border border-gray-600 flex items-center justify-center" data-id="element-30">
                {/* Using the main product image but zoomed/cropped via CSS to represent bonuses */}
                <img src={CONSTANTS.PRODUCT_IMAGE} alt={`Bono ${index + 1}`} className="w-[200%] h-[200%] object-cover object-center opacity-80 group-hover:opacity-100 transition-opacity" loading="lazy" data-id="element-31" />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent" data-id="element-32"></div>
                <span className="absolute bottom-2 left-0 right-0 text-center font-black text-2xl text-white/50" data-id="element-33">
                  #{index + 1}
                </span>
              </div>

              <div className="flex-1 text-center sm:text-left" data-id="element-34">
                <span className="inline-block bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-3" data-id="element-35">
                  GRATIS POR HOY
                </span>
                <h3 className="text-xl font-bold text-yellow-400 mb-2 leading-tight" data-id="element-36">
                  {bonus.title}
                </h3>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-37">
                  {bonus.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="max-w-3xl mx-auto bg-gradient-to-r from-green-600 to-green-500 rounded-3xl p-8 text-center shadow-2xl border border-green-400" data-id="element-38">
          <h3 className="text-2xl md:text-3xl font-black mb-4" data-id="element-39">
            En total recibís 6 recursos completos
          </h3>
          <p className="text-green-100 mb-8 text-lg" data-id="element-40">
            El Ebook Principal + Los 5 Bonos Exclusivos listos para descargar
          </p>

          <button onClick={scrollToOffer} className="w-full sm:w-auto bg-white text-green-700 hover:bg-gray-50 font-black text-xl py-4 px-10 rounded-full shadow-lg transform hover:-translate-y-1 transition-all duration-200 flex items-center justify-center mx-auto" data-id="element-41">
            QUIERO TODO EL PACK AHORA
            <ChevronRight className="ml-2 w-6 h-6" data-id="element-42" />
          </button>
        </div>
      </div>
    </section>;
};